export const RESUBMIT_TO_SAGE_SALES_INVOICE_MUTATION = gql`
    mutation ResubmitToSageSalesInvoice($id: Int!) {
        resubmitToSageSalesInvoice(id: $id) {
            id
            status
            sageInvoiceId
            sageInvoiceStatus
            sageInvoiceNumber
        }
    }
`;
